"use client"

import React from "react"
import { motion } from "framer-motion"
import { AlertCircle } from "lucide-react"
import type { LucideIcon } from "lucide-react"

interface EmptyStateProps {
    title?: string
    description?: string
    icon?: LucideIcon
}

function EmptyState({
    title = "No statuses found",
    description = "It looks like there are no statuses available yet. Try adjusting your filters or add a new one to get started.",
    icon: Icon,
}: EmptyStateProps) {
    const RenderIcon = Icon || AlertCircle

    return (
        <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col items-center justify-center py-20 text-center border border-dashed rounded-lg bg-gray-50 dark:bg-gray-900 dark:border-gray-800"
        >
            {/* Animated Floating Icon */}
            <motion.div
                animate={{ y: [0, -6, 0] }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                whileHover={{ scale: 1.08 }}
                className="mb-4"
            >
                <RenderIcon className="h-12 w-12 text-gray-400 dark:text-gray-500" />
            </motion.div>

            {/* Title */}
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                {title}
            </h3>

            {/* Description */}
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 max-w-sm">
                {description}
            </p>
        </motion.div>
    )
}

export default EmptyState
